import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/component/shared/services/auth.service';
import { CommonService } from 'src/app/component/shared/services/common.service';
import { UploadVideoModalComponent } from './upload-video-modal/upload-video-modal.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import {
  NgbmsMediaMgmtService,
  V1GetAllButtonDownloadStatusGet200ResponseVideoListInner as DeviceVideoItem,
  V1GetAllVideosGet200ResponseListInner as VideoItem,
  V1SendButtonStatusVideoIdVehicleNumPostRequest,
} from 'src/app/component/shared/services/openapi/media-mgmt';
import moment, { Moment } from 'moment';
import { environment } from 'src/environments/environment';
import { ConfirmModalComponent } from 'src/app/component/shared/services/confirm-modal/confirm-modal.component';

export const COLUMN_LIST: { id: string; name: string }[] = [
  {
    id: 'id',
    name: 'ID',
  },
  {
    id: 'videoName',
    name: 'Name',
  },
  {
    id: 'videoFileSize',
    name: 'File Size',
  },
  {
    id: 'checksum',
    name: 'MD5 Checksum',
  },
  {
    id: 'createdAt',
    name: 'Date Uploaded',
  },
  {
    id: 'uploadedBy',
    name: 'Uploader',
  },
  {
    id: 'flagPlay',
    name: 'Active Video',
  },
  {
    id: 'Actions',
    name: 'Actions',
  },
];

export const DEVICE_COLUMN_LIST: { id: string; name: string }[] = [
  // {
  //   id: 'id',
  //   name: 'ID',
  // },
  {
    id: 'busRegNo',
    name: 'Vehicle Number',
  },
  {
    id: 'buttonStatus',
    name: 'Play Status',
  },
  {
    id: 'downloadStatus',
    name: 'Download Status',
  },
  {
    id: 'updatedAt',
    name: 'Last Update',
  },
  {
    id: 'videoPlayerName',
    name: 'Selected Video',
  },
  {
    id: 'Actions',
    name: 'Actions',
  },
];

@Component({
  selector: 'app-video-management',
  templateUrl: './video-management.component.html',
  styleUrls: ['./video-management.component.scss'],
})
export class VideoManagementComponent implements OnInit, AfterViewInit {
  pageData = {
    id: 99,
    name: 'videoManagement',
    displayPageName: 'Video Management',
  };
  isNewWindow: boolean = false;
  isHasAccess: boolean = true;
  rightsError: string = '';

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private _commonService: CommonService,
    private _snackBar: MatSnackBar,
    public authService: AuthService,
    private mediaMgmtService: NgbmsMediaMgmtService
  ) {
    this.dataSource = new MatTableDataSource<any>();
    this.deviceDataSource = new MatTableDataSource<DeviceVideoItem>();
    this.dataSource.sortData = this.sortData;
    this.deviceDataSource.sortData = this.sortData;
  }
  intervalDevice;
  ngOnInit() {
    setTimeout(() => {
      if (this.route.snapshot.params.id === '2') {
        this.isNewWindow = true;
      }
      this.getVideoList();
      this.getDeviceVideoStatus();
      this.intervalDevice = setInterval(() => this.refetchVideoStatus(), 10000);
    }, 500);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.sort.sort({ id: 'createdAt', start: 'desc' } as MatSortable);
    this.dataSource.paginator = this.paginator;

    this.deviceDataSource.sort = this.deviceSort;
    this.deviceSort.sort({ id: 'busRegNo', start: 'asc' } as MatSortable);
    this.deviceDataSource.paginator = this.devicePaginator;
  }

  ngOnDestroy() {
    clearInterval(this.intervalDevice);
  }

  openWindow() {
    this._router.navigate(['/account/home']);
    let newwin = window.open(
      'account/media/video-management//2',
      'Video Management',
      'height=' + screen.height + ', width=' + screen.width + ' '
    );
    if (window.focus) {
      newwin.focus();
    }
    return false;
  }

  /**
   * Video List
   */
  columnList = COLUMN_LIST;
  displayedColumns: string[] = [
    'id',
    'videoName',
    'checksum',
    'videoFileSize',
    'createdAt',
    'uploadedBy',
    'flagPlay',
    'Actions',
  ];
  dataPage;
  filteredPage;
  dataSource;
  activeVideoRecord: VideoItem;
  @ViewChild('mediapaginator') paginator: MatPaginator;
  @ViewChild('mediatable', { static: true }) sort: MatSort;
  isLoading: boolean = true;

  sortData(records: VideoItem[] | DeviceVideoItem[], sort: MatSort) {
    // console.log('Sort: ', sort);
    const { active, direction } = sort;
    if (!active || direction === '') {
      return records;
    }
    return records.sort((a: VideoItem, b: VideoItem) => {
      let comparisonResult = 0;
      switch (active) {
        case 'createdAt':
          let timeA: Moment = moment(a[active]).utcOffset(environment.timezone);
          let timeB: Moment = moment(b[active]).utcOffset(environment.timezone);
          if (timeA.isValid() && !timeB.isValid()) return -1;
          if (!timeA.isValid() && timeB.isValid()) return 1;
          if (timeA.isSame(timeB)) return 0;
          comparisonResult = timeA.isAfter(timeB) ? 1 : -1;
          break;
        case 'videoFileSize':
        case 'id':
          comparisonResult = a[active] - b[active];
          break;
        case 'flagPlay':
          comparisonResult = a[active] === b[active] ? 0 : a[active] ? -1 : 1;
          break;
        default:
          comparisonResult = a[active].localeCompare(b[active]);
      }
      return comparisonResult * (direction === 'asc' ? 1 : -1);
    });
  }

  getVideoList() {
    this.isLoading = true;
    this.mediaMgmtService.v1GetAllVideosGet().subscribe(
      result => {
        console.log('Get Files: ', result);
        const { list = [] } = result;
        this.dataSource.data = list;

        this.activeVideoRecord = list.find(item => item.flagPlay);

        this.isLoading = false;
      },
      e => {
        console.log('Videos: Failed to get videos: ', e);
        this._snackBar.open(
          `Failed to fetch list of videos. Please refresh the page.`,
          null,
          {
            duration: 3000,
            panelClass: 'custom-snack-bar-panel-error',
          }
        );
      }
    );
  }

  onDelete(record: VideoItem) {
    const { videoName, id } = record;
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        header: 'Delete Video',
        message: `Are you sure you want to delete ${videoName}?`,
        textConfirm: 'Delete',
        textCancel: 'Cancel',
        mode: 'warn',
      },
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.isLoading = true;

        this.mediaMgmtService.v1DeleteVideoIdDelete(id).subscribe(
          result => {
            console.log('delete result', result);
            setTimeout(() => {
              const filteredData = this.dataSource.data.filter(
                (record: VideoItem) => record.videoName !== videoName
              );
              this.dataSource.data = filteredData;
              this.isLoading = false;

              this._snackBar.open(`${videoName} has been deleted`, null, {
                duration: 5000,
              });
            }, 0);
          },
          err => {
            console.log('error: ', err);
            this.isLoading = false;
            this._snackBar.open(
              `There was an error deleting the video. Please try again.`,
              null,
              {
                duration: 5000,
                panelClass: 'custom-snack-bar-panel-error',
              }
            );
          }
        );
      }
    });
  }

  openUploadModal() {
    const dialogRef = this.dialog.open(UploadVideoModalComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log('Result: ', result);
      if (result) {
        this.getVideoList();
      }
    });
  }

  setActive(data: VideoItem) {
    const { videoName, id, flagPlay } = data;
    if (!flagPlay) {
      this.mediaMgmtService
        .v1UpdateFlagOfVideoVideoIdPost(id, undefined, undefined, {
          flagPlay: 1,
        })
        .subscribe(
          result => {
            if (result) {
              data.flagPlay = true;
              this.dataSource.data.forEach(item => {
                if (item.id !== id) {
                  item.flagPlay = false;
                }
              });
              this.activeVideoRecord = data;
              console.log('Active Video: ', this.activeVideoRecord);
              this._snackBar.open(
                `${videoName} has been set as the active video.`,
                null,
                {
                  duration: 5000,
                }
              );
            }
          },
          e => {
            console.error('Flag Error: ', e);
            this._snackBar.open(
              `There was an error updating the active video. Please try again.`,
              null,
              {
                duration: 5000,
                panelClass: 'custom-snack-bar-panel-error',
              }
            );
          }
        );
    } else {
      this._snackBar.open(`Video is already active.`, null, {
        duration: 3000,
      });
    }
  }

  /**
   * Device Video Status
   */
  deviceLoading = true;
  deviceColumnList = DEVICE_COLUMN_LIST;
  deviceDisplayedColumns: string[] = [
    'busRegNo',
    'videoPlayerName',
    'updatedAt',
    'downloadStatus',
    'buttonStatus',
    'Actions',
  ];
  deviceDataSource: MatTableDataSource<DeviceVideoItem>;
  @ViewChild('devicePaginator') devicePaginator: MatPaginator;
  @ViewChild('vehicleStatus', { static: true }) deviceSort: MatSort;
  getDeviceVideoStatus(setLoading = true, showError = true) {
    this.deviceLoading = setLoading;
    this.mediaMgmtService.v1GetAllButtonDownloadStatusGet().subscribe(
      result => {
        console.log('Get Files: ', result);
        const { videoList = [] } = result;
        this.deviceDataSource.data = videoList;
        this.deviceLoading = false;
      },
      e => {
        this.deviceLoading = false;
        console.log('Device Video: Failed to get videos: ', e);
        if (showError) {
          this._snackBar.open(
            `Failed to fetch list. Please refresh the page.`,
            null,
            {
              duration: 3000,
              panelClass: 'custom-snack-bar-panel-error',
            }
          );
        }
      }
    );
  }

  refetchVideoStatus() {
    this.getDeviceVideoStatus(false, false);
  }

  onPlay(record: DeviceVideoItem) {
    if (record?.downloadStatus) {
      const {
        busRegNo,
        videoPlayerName,
        videoPlayerId,
        buttonStatus: oldButtonStatus,
      } = record;

      if (videoPlayerName !== this.activeVideoRecord?.videoName) {
        this._snackBar.open(
          `Cannot update state. Video on device does not match with the currently active video.`,
          null,
          {
            duration: 3000,
            panelClass: 'custom-snack-bar-panel-error',
          }
        );
        return;
      }

      const body: V1SendButtonStatusVideoIdVehicleNumPostRequest = {
        buttonStatus: oldButtonStatus === 'stop' ? 'start' : 'stop',
      };
      this.mediaMgmtService
        .v1SendButtonStatusVideoIdVehicleNumPost(
          videoPlayerId,
          busRegNo,
          undefined,
          undefined,
          body
        )
        .subscribe(
          result => {
            const { buttonStatus } = result;
            this._snackBar.open(
              `Video state has been set to ${buttonStatus} for ${busRegNo}`,
              null,
              {
                duration: 3000,
              }
            );
            record.buttonStatus = buttonStatus;
          },
          e => {
            console.log('Device Video: Failed to update video status: ', e);
            this._snackBar.open(
              `Failed to update video state. Please try again.`,
              null,
              {
                duration: 3000,
                panelClass: 'custom-snack-bar-panel-error',
              }
            );
          }
        );
    } else {
      this._snackBar.open(`Video is not yet downloaded on device.`, null, {
        duration: 3000,
        panelClass: 'custom-snack-bar-panel-error',
      });
    }
  }
}
